//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailMixin from '@/mixins/DetailMixin';

export default {
    mixins: [
        DetailMixin,
    ],

    props: {
        titleFn: [String, Function],
        newTitleVariantFn: [String, Function],
        canDelete: Boolean,
        autoHeight: Boolean,
        leftTabs: Boolean,
    },

    computed: {
        title() {
            return (
                this.item || this.newTitleVariantFn === 'custom' ? (typeof this.titleFn === 'function' ? this.titleFn(this.item, this.editItem) : $.get(this.item, this.titleFn)) :
                this.editItem ? $.t(`nu.${this.collName}${this.newTitleVariantSuffix}`) :
                null
            );
        },
        titleIcon() {
            return this.item?.archived ? 'lock' : null;
        },
        newTitleVariantSuffix() {
            const variant = typeof this.newTitleVariantFn === 'function'
                ? this.newTitleVariantFn(this.editItem)
                : this.newTitleVariantFn;

            return variant ? `.${variant}` : '';
        },
    },

    watch: {
        isDirty(val) {
            this.$emit('update:isDirty', val);
        },
    },

    meta() {
        return {
            title: this.title,
        };
    },
};
